import createHasSubmitSucceeded from '../selectors/hasSubmitSucceeded';
import immutable from '../structure/immutable';

export default createHasSubmitSucceeded(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/hasSubmitSucceeded.js
// module id = 1204
// module chunks = 0